<!-- <nav class="layout-breadcrumb">
    <ol>
        <li>
            <a [routerLink]="['/']">
                <i class="pi pi-home"></i>
            </a>
        </li>
        <li class="layout-breadcrumb-chevron"> > </li>
        <ng-template ngFor let-item let-last="last" [ngForOf]="breadcrumbs$ | async">
            <li><a [routerLink]="item.url">{{item.label}}</a></li>
            <li *ngIf="!last" class="layout-breadcrumb-chevron"> > </li>
        </ng-template>
    </ol>
</nav> -->


<nav class="layout-breadcrumb">
    <ol>
        <li>
            <a [routerLink]="['/']">
                <i class="pi pi-home"></i>
            </a>
        </li>
        <li class="layout-breadcrumb-chevron"> > </li>
        <ng-container *ngFor="let item of breadcrumbs$ | async; let last = last">
            <li>
                <ng-container *ngIf="item.url; else plainLabel">
                    <a [routerLink]="getRouterLink(item.url)" (click)="handleBreadcrumbClick($event, item)">
                        {{item.label}}
                    </a>
                </ng-container>
                <ng-template #plainLabel>
                    <span>{{item.label}}</span>
                </ng-template>
            </li>
            <li *ngIf="!last" class="layout-breadcrumb-chevron"> > </li>
        </ng-container>
    </ol>
</nav>